/**
 * Format a number with grouped thousands
 *
 * @param  {int} number     The number being formatted
 *
 * @return {string}         A formatted version of number
 */
export function formatAmount(number) {
    let result = `${number}`;
    return result.replace(/\B(?=(\d{3})+(?!\d))/g, '.');
}
